<template>
  <div
    ref="map"
    class="md:col-start-1 md:col-end-4 w-full h-96 md:h-120 xl:h-150 rounded"
  >
    <div
      v-for="({ icon, position, title, distance }, key) in markers"
      :key="key"
      :data-title="title"
      :data-distance="distance"
      :data-icon="icon"
      :data-lat="position.lat"
      :data-lng="position.lng"
      ref="marker"
    ></div>
  </div>
</template>

<script>
const mapStyle = [
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e9e9e9',
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 29,
      },
      {
        weight: 0.2,
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 18,
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5',
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dedede',
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#ffffff',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        saturation: 36,
      },
      {
        color: '#333333',
      },
      {
        lightness: 40,
      },
    ],
  },
  {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f2f2f2',
      },
      {
        lightness: 19,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fefefe',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#fefefe',
      },
      {
        lightness: 17,
      },
      {
        weight: 1.2,
      },
    ],
  },
];

export default {
  props: {
    markers: {
      type: Array,
      default: [],
    },
    lat: {
      type: [Number, String],
      default: 0,
    },
    lng: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      icon: '<svg width="73" height="86" viewBox="0 0 73 86" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="73" height="73" fill="#C49F8A"/><path d="M37.1138 50C35.4569 50.0011 33.8128 49.7226 32.2583 49.1774C30.6875 48.6313 29.2418 47.8032 28 46.7382L30.7869 43.5629C32.9046 45.2081 35.0424 46.0308 37.2004 46.0308C37.9954 46.0714 38.7859 45.8928 39.4767 45.5166C39.7337 45.3723 39.9457 45.1655 40.091 44.9176C40.2362 44.6697 40.3095 44.3895 40.3033 44.1058V44.0482C40.3168 43.6904 40.2007 43.339 39.9744 43.0528C39.621 42.7006 39.1872 42.4304 38.7064 42.2631C37.819 41.9207 36.9045 41.6456 35.9714 41.4405C35.2905 41.2787 34.7034 41.1238 34.21 40.9757C33.7167 40.8276 33.2061 40.6562 32.6781 40.4615C32.2145 40.2892 31.7684 40.0772 31.3452 39.8281C30.9714 39.5992 30.6221 39.336 30.3023 39.0425C29.9787 38.7524 29.7082 38.4133 29.5017 38.0389C29.2858 37.6337 29.1258 37.2038 29.0256 36.7597C28.912 36.2514 28.8583 35.7327 28.8655 35.2131V35.1555C28.8344 34.3098 29.0069 33.4685 29.3699 32.6958C29.7329 31.9231 30.2768 31.2394 30.9601 30.6969C32.3651 29.5671 34.1711 29.0022 36.3782 29.0022C39.2745 28.9486 42.0981 29.866 44.3538 31.5935L41.8958 34.9828C39.8445 33.6364 37.9851 32.9632 36.3176 32.9632C35.5979 32.9257 34.8838 33.1025 34.275 33.4691C34.0502 33.6079 33.8658 33.7981 33.7388 34.0224C33.6117 34.2467 33.5461 34.4977 33.5479 34.7524V34.81C33.5375 35.1143 33.6162 35.4154 33.7751 35.6797C33.934 35.944 34.167 36.1613 34.4481 36.3072C35.0482 36.65 36.2974 37.049 38.1957 37.5042C39.1891 37.7341 40.1627 38.0353 41.1082 38.4049C41.8661 38.7117 42.5755 39.1173 43.2157 39.6101C43.8075 40.0624 44.2715 40.6476 44.5659 41.313C44.8687 42.0446 45.0158 42.8261 44.9987 43.6122V43.6698C44.9987 45.6551 44.2774 47.2058 42.8349 48.3218C41.3924 49.4379 39.4853 49.9973 37.1138 50Z" fill="white"/><path d="M42 27H31V22H42V27Z" fill="white"/><rect x="36" y="60" width="18" height="18" transform="rotate(45 36 60)" fill="#C49F8A"/></svg>',
      map: null,
    };
  },
  methods: {
    initMap(el) {
      const args = {
        zoom: 9,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: mapStyle,
        scaleControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_TOP,
        },
      };

      this.map = new google.maps.Map(el, args);
      this.map.markers = [];

      this.$refs.marker.forEach((marker, i) => {
        this.addMarker(marker, i);
      });

      this.centerMap();
    },
    addMarker(marker, id) {
      var latlng = new google.maps.LatLng(
        marker.dataset.lat,
        marker.dataset.lng
      );

      const size = id ? 120 : 180;
      const responsiveSize = size / (window.innerWidth < 767 ? 1.8 : 1);

      const anchorX = id ? 60 : 90;
      const anchorY = id ? 100 : 140;

      const responsiveAnchorX = anchorX / (window.innerWidth < 767 ? 1.8 : 1);
      const responsiveAnchorY = anchorY / (window.innerWidth < 767 ? 1.8 : 1);

      const markerIcon = {
        url:
          'data:image/svg+xml;charset=UTF-8;base64,' +
          Buffer.from(marker.dataset.icon).toString('base64'),
        scaledSize: new google.maps.Size(responsiveSize, responsiveSize),
        anchor: new google.maps.Point(responsiveAnchorX, responsiveAnchorY),
      };

      var marker = new google.maps.Marker({
        position: latlng,
        map: this.map,
        icon: markerIcon,
        optimized: false,
        title: 'map-marker',
      });
      marker.setValues({ type: 'point', id });
      this.map.markers.push(marker);
    },
    centerMap() {
      const bounds = new google.maps.LatLngBounds();

      this.map.markers.forEach((marker) => {
        bounds.extend(
          new google.maps.LatLng(marker.position.lat(), marker.position.lng())
        );
      });

      if (this.map.markers.length > 1) return this.map.fitBounds(bounds);
      this.map.setCenter(bounds.getCenter());
      this.map.setZoom(15);
    },
  },
  mounted() {
    this.initMap(this.$refs.map);
  },
};
</script>
